import { useLocalSearchParams } from 'expo-router';
import EventDetailBadge from '@/screens/EventDetailBadge';

export default function PrivateTabsEventEventIdBadgeRoute() {
  const { eventId } = useLocalSearchParams<{ eventId: string }>();

  return <EventDetailBadge eventId={eventId ?? ''} />;
}
